import Axios from "axios";


export async function GetUser(){
    let response = await Axios.get(process.env.REACT_APP_BACKEND_URL + "/get-user")
    if(response.data && response.data["user"] && response.data["user"].email){
        return new Promise(resolve => resolve(response.data["user"]));
    }else{
        return new Promise(resolve => resolve(null));
    }
}
